import React from 'react';
import GoogleChartsContainer from '../../Componant/Charts/GoogleCharts';

const GoogleCharts = () => {
  return (
    <div className='page-body'>
      <GoogleChartsContainer />
    </div>
  );
};

export default GoogleCharts;
